import React from 'react';
import styled from 'styled-components';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import FdrSrlGeoItemSkeleton from 'fdr/components/local/fdr-srl-ui/fdr-srl-geo-item.skeleton';

interface ISRLUiSkeletonProps {
  counts?: number;
}

const WishlistListViewSkeletonWrapper = styled.div(
  sx2CssThemeFn({
    width: '100%',
    pl: [null, '15px'],
  })
);

const GeoItemsWrapper = styled.div(
  sx2CssThemeFn({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    flexDirection: 'column',
    mb: 3,
    '.geo-item-skeleton-wrap': {
      '&:not(:last-child)': {
        mb: [3, '20px'],
      },
    },
  })
);

const WishlistListViewSkeleton: React.FC<ISRLUiSkeletonProps> = ({
  counts = 2,
}) => {
  return (
    <WishlistListViewSkeletonWrapper>
      <GeoItemsWrapper>
        {Array.from({ length: counts }, (_, i) => (
          <div key={i} className="geo-item-skeleton-wrap">
            <FdrSrlGeoItemSkeleton />
          </div>
        ))}
      </GeoItemsWrapper>
    </WishlistListViewSkeletonWrapper>
  );
};

export default WishlistListViewSkeleton;
